// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1ymCW","legacyBtn":"MutateMid_legacyBtn__1-5Cx"};